import { z } from "zod";
import { BlockDefs } from "./defs/blocks";

const LeafBlockOptions = {
  ReaderLayoutTableOfContents: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutTableOfContents"),
    props: BlockDefs.ReaderLayoutTableOfContents.propsSchema,
  }),
  ReaderLayoutSettings: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutSettings"),
    props: BlockDefs.ReaderLayoutSettings.propsSchema,
  }),
  ReaderLayoutBookmarks: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutBookmarks"),
    props: BlockDefs.ReaderLayoutBookmarks.propsSchema,
  }),
  ReaderLayoutHighlights: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutHighlights"),
    props: BlockDefs.ReaderLayoutHighlights.propsSchema,
  }),
  ReaderLayoutProgressSlider: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutProgressSlider"),
    props: BlockDefs.ReaderLayoutProgressSlider.propsSchema,
  }),
  ReaderLayoutButton: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutButton"),
    props: BlockDefs.ReaderLayoutButton.propsSchema,
  }),
  ReaderLayoutReadAloudButton: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutReadAloudButton"),
    props: BlockDefs.ReaderLayoutReadAloudButton.propsSchema,
  }),
  ReaderLayoutImage: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutImage"),
    props: BlockDefs.ReaderLayoutImage.propsSchema,
  }),
  ReaderLayoutLabel: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutLabel"),
    props: BlockDefs.ReaderLayoutLabel.propsSchema,
  }),
  ReaderLayoutInput: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutInput"),
    props: BlockDefs.ReaderLayoutInput.propsSchema,
  }),
  ReaderLayoutToast: z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutToast"),
    props: BlockDefs.ReaderLayoutToast.propsSchema,
  }),
};

export const LeafBlockSchema = z.discriminatedUnion("type", [
  LeafBlockOptions.ReaderLayoutTableOfContents,
  LeafBlockOptions.ReaderLayoutSettings,
  LeafBlockOptions.ReaderLayoutBookmarks,
  LeafBlockOptions.ReaderLayoutHighlights,
  LeafBlockOptions.ReaderLayoutProgressSlider,
  LeafBlockOptions.ReaderLayoutButton,
  LeafBlockOptions.ReaderLayoutReadAloudButton,
  LeafBlockOptions.ReaderLayoutImage,
  LeafBlockOptions.ReaderLayoutLabel,
  LeafBlockOptions.ReaderLayoutInput,
  LeafBlockOptions.ReaderLayoutToast,
] as const);

export const LayoutBlockSchema: z.ZodTypeAny = z.union([
  LeafBlockSchema,
  z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutModal"),
    props: z.union([
      z.record(z.string(), BlockDefs.ReaderLayoutModal.propsSchema),
      BlockDefs.ReaderLayoutModal.propsSchema,
    ]),
    children: z.lazy(() => z.array(LayoutBlockSchema)),
  }),
  z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutContainer"),
    props: z.union([
      z.record(z.string(), BlockDefs.ReaderLayoutContainer.propsSchema),
      BlockDefs.ReaderLayoutContainer.propsSchema,
    ]),
    children: z.lazy(() => z.array(LayoutBlockSchema)),
  }),
  z.object({
    id: z.string().min(1),
    type: z.literal("ReaderLayoutLink"),
    props: BlockDefs.ReaderLayoutLink.propsSchema,
    children: z.lazy(() => z.array(z.union([
      LeafBlockOptions.ReaderLayoutButton,
      LeafBlockOptions.ReaderLayoutImage
    ]))),
  })
]);

export type LayoutBlock = z.infer<typeof LayoutBlockSchema>;
